import api from "@/api";
import RecoveryMethod from "@/types/RecoveryMethod";

export default async function sendPasswordRecoveryCode(document: string, method: RecoveryMethod): Promise<boolean> {
  await api.post("/api/password/code", { document: document.replace(/[^A-Z0-9]/gi, ""), method: method.name });

  return true;
}
